import Controller from "csi/action/Controller";
import localeProvider from "csi/page/localeProvider";
import declare from "dojo/_base/declare";
import { createMassUpdateBOMStore } from "./MassUpdateBOMService";

const MassUpdateBOMsController = declare(Controller, {

	/** @override use store instead of actioncontroller */
	async onReactViewProps(props) {
		const { m_cache, m_formData, m_action } = this;
		props.store = await createMassUpdateBOMStore(m_action.getId(), m_cache, m_formData, this.getNode() || this.getParent(), props.onClose, props.onSave, localeProvider);
	},
});

export = MassUpdateBOMsController;	